import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


const Header = (
  {
    countAdults,
    countChildren,
  },
) => {
  const { t } = useTranslation('common_volunteering')

  return (
    <span>{countAdults} {t('volunteersCounterAdult')} + {countChildren} {t('volunteersCounterChild')}</span>
  )
}

Header.propTypes = {
  countAdults: PropTypes.number,
  countChildren: PropTypes.number,
}

Header.defaultProps = {}

export default Header
